import { render } from "./editors.vue?vue&type=template&id=779a10fe"
import script from "./editors.vue?vue&type=script&lang=js"
export * from "./editors.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__